// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__P4TO8","commercialChargingPage":"styles_commercialChargingPage__nwonl","formHolder":"styles_formHolder__06qGO"};